export default {
    workOrder_customerSelector_title: "Select Customer",
    workOrder_customerSelector_customer: "Customer",
    workOrder_customerSelector_create_new_customer: "Create New Customer",
    workOrder_customerSelector_contact: "Contact",
    workOrder_customerSelector_create_new_contact: "Create New Contact",
    workOrder_customerSelector_location: "Location",
    workOrder_customerSelector_create_new_location: "Create New Location",
};